import { CustomModalRejectConfirm } from "../app/shared/components";

const ModalRejectConfirmPlugin = {
    install(Vue) {
        this.EventBus = new Vue();
        Vue.component('modal-reject-confirm', CustomModalRejectConfirm);
        Vue.prototype.$modalRejectConfirm = {
            show(params) {
                ModalRejectConfirmPlugin.EventBus.$emit('show', params);
            },
            hide() {
                ModalRejectConfirmPlugin.EventBus.$emit('hide');
            }
        }
    }
};

export default ModalRejectConfirmPlugin
